module.exports = __webpack_public_path__ + "product-pure-powder-capsule-06.jpg?fae2f3210247cfb64c3621284456ec4c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product-pure-powder-capsule-06.jpg
// module id = 88
// module chunks = 0